import { Component, ElementRef, Inject, OnInit, QueryList, ViewChildren } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { Subscription } from 'rxjs';
import * as _ from 'lodash';
import { Column, ColumnEditorDialogData } from 'src/app/core/interfaces/columns';
@Component({
  selector: 'app-column-editor-dialog',
  templateUrl: './column-editor-dialog.component.html',
  styleUrls: ['./column-editor-dialog.component.scss']
})
export class ColumnEditorDialogComponent implements OnInit {
  columns: Column[] = [];
  defaultColumns: Column[] = [];
  activeItem: number = 0;
  subscription: Subscription = new Subscription();
  translationKeyPrefix: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ColumnEditorDialogData,
    public dialogRef: MatDialogRef<ColumnEditorDialogComponent>
  ) { }

  @ViewChildren("dragHandle") dragHandles: QueryList<ElementRef> = {} as QueryList<ElementRef>;

  ngAfterViewInit() {
    this.subscription = this.dragHandles.changes.subscribe(() => {
      this.setFocus();
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  ngOnInit() {
    this.translationKeyPrefix = this.data.translationKeyPrefix;
    this.columns = this.data.columns;
    this.defaultColumns = this.data.defaultColumns;
  }

  dropItem(event: CdkDragDrop<[]>) {
    this.activeItem = -1; // So focus is not set on the dropped item
    moveItemInArray(this.columns, event.previousIndex, event.currentIndex);
  }

  setFocus() {
    if (this.activeItem > -1) {
      this.dragHandles.toArray()[this.activeItem].nativeElement.focus();
    }
  }

  handleKeyDown(event: KeyboardEvent, currentIndex: number) {
    let newIndex = currentIndex;
    if (event.key === 'ArrowDown' || event.key === 'ArrowRight' || event.key === 'PageDown') {
      newIndex += 1;
    }
    if (event.key === 'ArrowUp' || event.key === 'ArrowLeft' || event.key === 'PageUp') {
      newIndex -= 1;
    }
    if (-1 < newIndex && newIndex < this.columns.length) {      
      moveItemInArray(this.columns, currentIndex, newIndex);
      this.activeItem = newIndex;
      this.setFocus();
    }
  }

  resetToDefault() {
    this.activeItem = -1; // So focus is not set
    this.columns = _.cloneDeep(this.defaultColumns);
  }

  //at least one column selected
  isValid(): boolean {
    return Boolean(this.columns.find((column: Column) => column.show));
  }

  onCancel(): void {
    this.dialogRef.close([]);
  }

  onApply(): void {
    this.dialogRef.close(this.columns);
  }
}
